module.exports = __webpack_public_path__ + "img/NL234.b1ab875c.svg";